import './search.css'

import { CloseButton, Loader, Modal } from 'components'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import type { State } from 'store/types'

import Box from '@mui/material/Box'

import { closeSearch } from './actions'
import SearchInputContainer from './SearchInputContainer'
import SearchResultsContainer from './SearchResultsContainer'
import SearchSummaryContainer from './SearchSummaryContainer'
import * as selectors from './selectors'

function Search() {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch()
  const isFetchingStores = useSelector((state: State) => state.search.isFetchingStores)
  const showSelectedOnly = useSelector((state: State) => state.search.showSelectedOnly)
  const isOpen = useSelector(selectors.isOpen)
  const trackOnClose = () => dispatch(closeSearch())

  if (!isOpen) return null

  return (
    <Modal className="search-modal">
      <Box className="search-wrapper">
        <Box className="search-header">
          <span>{translate(showSelectedOnly ? 'search.results' : 'search.title')}</span>
          <CloseButton onClick={trackOnClose} />
        </Box>
        <Box className="search-control">
          <SearchInputContainer />
          <SearchSummaryContainer />
        </Box>
        <Box className="search-list">{isFetchingStores ? <Loader /> : <SearchResultsContainer />}</Box>
      </Box>
    </Modal>
  )
}

export default Search as any
